import { useFetchAccountingResourcesQuery } from "../services/api/accountingResourcesApi/accountingResources";

import { useRouteOrganisationId } from "./useRouteOrganisationId";

export function useAccountingResources() {
  const { organisationId } = useRouteOrganisationId();
  const result = useFetchAccountingResourcesQuery(organisationId, {
    skip: !organisationId,
  });

  return result;
}
